module.exports = __webpack_public_path__ + "img/logo-carne-joven-aragon.7966729e.svg";